__turbopack_context__.v({
  "delete": "CapacityConflictVisualIcon-module-scss-module__SitLDW__delete",
  "icon": "CapacityConflictVisualIcon-module-scss-module__SitLDW__icon",
  "iconCircle": "CapacityConflictVisualIcon-module-scss-module__SitLDW__iconCircle",
});
